module.exports = __webpack_public_path__ + "static/media/gria-premium-icon.e143dcb9.svg";